var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var Wallet = require('ethereumjs-wallet');

var ethUtil = require('ethereumjs-util');

var type = 'Simple Key Pair';

var sigUtil = require('eth-sig-util');

var SimpleKeyring =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(SimpleKeyring, _EventEmitter);

  /* PUBLIC METHODS */
  function SimpleKeyring(opts) {
    var _this;

    _classCallCheck(this, SimpleKeyring);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleKeyring).call(this));
    _this.type = type;
    _this.wallets = [];

    _this.deserialize(opts);

    return _this;
  }

  _createClass(SimpleKeyring, [{
    key: "serialize",
    value: function serialize() {
      return Promise.resolve(this.wallets.map(function (w) {
        return w.getPrivateKey().toString('hex');
      }));
    }
  }, {
    key: "deserialize",
    value: function deserialize() {
      var _this2 = this;

      var privateKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return new Promise(function (resolve, reject) {
        try {
          _this2.wallets = privateKeys.map(function (privateKey) {
            var stripped = ethUtil.stripHexPrefix(privateKey);
            var buffer = new Buffer(stripped, 'hex');
            var wallet = Wallet.fromPrivateKey(buffer);
            return wallet;
          });
        } catch (e) {
          reject(e);
        }

        resolve();
      });
    }
  }, {
    key: "addAccounts",
    value: function addAccounts() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var newWallets = [];

      for (var i = 0; i < n; i++) {
        newWallets.push(Wallet.generate());
      }

      this.wallets = this.wallets.concat(newWallets);
      var hexWallets = newWallets.map(function (w) {
        return ethUtil.bufferToHex(w.getAddress());
      });
      return Promise.resolve(hexWallets);
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return Promise.resolve(this.wallets.map(function (w) {
        return ethUtil.bufferToHex(w.getAddress());
      }));
    } // tx is an instance of the ethereumjs-transaction class.

  }, {
    key: "signTransaction",
    value: function signTransaction(address, tx) {
      var wallet = this._getWalletForAccount(address);

      var privKey = wallet.getPrivateKey();
      tx.sign(privKey);
      return Promise.resolve(tx);
    } // For eth_sign, we need to sign arbitrary data:

  }, {
    key: "signMessage",
    value: function signMessage(withAccount, data) {
      var wallet = this._getWalletForAccount(withAccount);

      var message = ethUtil.stripHexPrefix(data);
      var privKey = wallet.getPrivateKey();
      var msgSig = ethUtil.ecsign(new Buffer(message, 'hex'), privKey);
      var rawMsgSig = ethUtil.bufferToHex(sigUtil.concatSig(msgSig.v, msgSig.r, msgSig.s));
      return Promise.resolve(rawMsgSig);
    } // For personal_sign, we need to prefix the message:

  }, {
    key: "signPersonalMessage",
    value: function signPersonalMessage(withAccount, msgHex) {
      var wallet = this._getWalletForAccount(withAccount);

      var privKey = ethUtil.stripHexPrefix(wallet.getPrivateKey());
      var privKeyBuffer = new Buffer(privKey, 'hex');
      var sig = sigUtil.personalSign(privKeyBuffer, {
        data: msgHex
      });
      return Promise.resolve(sig);
    } // personal_signTypedData, signs data along with the schema

  }, {
    key: "signTypedData",
    value: function signTypedData(withAccount, typedData) {
      var wallet = this._getWalletForAccount(withAccount);

      var privKey = ethUtil.toBuffer(wallet.getPrivateKey());
      var sig = sigUtil.signTypedData(privKey, {
        data: typedData
      });
      return Promise.resolve(sig);
    } // exportAccount should return a hex-encoded private key:

  }, {
    key: "exportAccount",
    value: function exportAccount(address) {
      var wallet = this._getWalletForAccount(address);

      return Promise.resolve(wallet.getPrivateKey().toString('hex'));
    }
  }, {
    key: "removeAccount",
    value: function removeAccount(address) {
      if (!this.wallets.map(function (w) {
        return ethUtil.bufferToHex(w.getAddress()).toLowerCase();
      }).includes(address.toLowerCase())) {
        throw new Error("Address ".concat(address, " not found in this keyring"));
      }

      this.wallets = this.wallets.filter(function (w) {
        return ethUtil.bufferToHex(w.getAddress()).toLowerCase() !== address.toLowerCase();
      });
    }
    /* PRIVATE METHODS */

  }, {
    key: "_getWalletForAccount",
    value: function _getWalletForAccount(account) {
      var address = sigUtil.normalize(account);
      var wallet = this.wallets.find(function (w) {
        return ethUtil.bufferToHex(w.getAddress()) === address;
      });
      if (!wallet) throw new Error('Simple Keyring - Unable to find matching address.');
      return wallet;
    }
  }]);

  return SimpleKeyring;
}(EventEmitter);

SimpleKeyring.type = type;
module.exports = SimpleKeyring;